import {Component, OnInit, Input} from '@angular/core'

import {Observable} from 'rxjs'
import {map, tap} from 'rxjs/operators'

import {UserManagerService} from '@app/core/services/user/user-manager.service'
import {Role} from '@app/core/services/rest-api'
import {User} from '@app/core/services/rest-api'
import {FormBuilder, FormGroup, Validators} from '@angular/forms'
import {Router} from '@angular/router'
import {ContextService} from '@app/core/services/context.service'
import {FormBasedComponent} from '../../../base/form-based.component'

interface NewUserInputConfig {
  showButtons?: boolean
  showContainer?: boolean
  showDomainInput?: boolean
  showSendPasswordEmail?: boolean
}
@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  providers: [UserManagerService],
  standalone: false,
})
export class NewUserComponent extends FormBasedComponent implements OnInit {
  // re-use in other parts of the app
  // submit needs to be triggered with a viewchild
  // form values need to be set with viewchild also.
  // submit buttons and container should be hideable
  // so optional configuration object
  defaultConfig = {
    showButtons: true,
    showContainer: true,
    showDomainInput: true,
    showSendPasswordEmail: false,
  }
  parsedConfig: NewUserInputConfig = {}
  @Input() config: NewUserInputConfig = {}

  nonEligibleEmail = false

  roles: Role[]

  hasAtleastOneCheckboxChecked = false

  constructor(
    protected formBuilder: FormBuilder,
    private managerSvc: UserManagerService,
    private contextSvc: ContextService,
    private router: Router,
  ) {
    super(formBuilder)
  }

  ngOnInit() {
    super.initForm()
    this.parsedConfig = {...this.defaultConfig, ...this.config}
    this.form = this.buildForm(this.formBuilder)

    this.form.valueChanges
      .pipe(
        tap((e) => {
          console.log(e)
          if (e.emailAddress && e.emailAddress.length > 0) {
            const _domain = e.domain
            if (_domain === 'PAYTER' || _domain === 'CURO') {
              if (
                e.emailAddress.includes('@payter.com') ||
                e.emailAddress.includes('@payter.nl')
              ) {
                this.nonEligibleEmail = false
              } else {
                this.nonEligibleEmail = true
              }
            } else {
              this.nonEligibleEmail = false
            }
          }
          this.hasAtleastOneCheckboxChecked = e.roles && e.roles.length
        }),
      )
      .subscribe()
  }

  buildForm(fb: FormBuilder): FormGroup {
    return fb.group({
      domain: fb.control(this.contextSvc.activeDomain, Validators.required),
      username: fb.control('', Validators.required),
      emailAddress: fb.control('', [Validators.required, Validators.email]),
      roles: fb.control([]),
      myPayterBeta: fb.control(false, []),
      mfa: fb.control({value: false, disabled: true}),
    })
  }

  get defaults() {
    return {
      domain: this.contextSvc.activeDomain,
      roles: [],
      myPayterBeta: false,
      mfa: false,
    }
  }

  get domain() {
    return this.form.get('domain')
  }

  processSubmit(form: FormGroup): Observable<any> {
    const user: User = {
      domain: form.get('domain').value,
      username: this.trim(form.get('username').value),
      emailAddress: this.trim(form.get('emailAddress').value),
      roles: form.get('roles').value,
      theme: form.get('myPayterBeta').value ? 'mypayter' : null,
      mfa: false,
    }
    return this.managerSvc.create(user).pipe(
      map(
        (created) => {
          this.router.navigate(['/administration/users', created.id])
        },
        (err: Error) => {
          // TODO global notification
          form.setErrors({global: err.message})
        },
      ),
    )
  }
}
